module.exports = __webpack_public_path__ + "img/logo_cleverdocs.e80bdb8e.png";